import { create } from 'zustand'

const useRepairsStore = create((set) => ({
  pendingRepairsDialog: null,
  setPendingRepairsDialog: (data) => set({ pendingRepairsDialog: data }),
  invoice_data: {},
  setInvoiceData: (data) => set({ invoice_data: data }),
}))

export default useRepairsStore;